import { useState, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Hook personalizado para manejar filtros de tabla usando `useSearchParams`
 */
const useTableFilters = (data) => {
  const [searchParams, setSearchParams] = useSearchParams();

  // Convertir `searchParams` en un objeto más manejable
  const initialFilters = Object.fromEntries(searchParams.entries());

  // Estado local para almacenar los filtros
  const [filters, setFilters] = useState(initialFilters);

  /**
   * Maneja cambios en los filtros y actualiza la URL.
   * - Si un filtro está vacío, se elimina de la URL.
   */
  const handleFilterChange = (columnId, value) => {
    const newFilters = { ...filters, [columnId]: value };

    // Eliminar filtros vacíos de la URL
    Object.keys(newFilters).forEach((key) => {
      if (!newFilters[key]) delete newFilters[key];
    });

    setFilters(newFilters);
    setSearchParams(newFilters);
  };

  const getNestedValue = (obj, path) => {
    return path.split("_").reduce((acc, key) => acc?.[key], obj);
  };

  /**
   * Filtra los datos en base a los filtros actuales.
   * Se ejecuta solo cuando `data` o `filters` cambian.
   */

  const filteredData = useMemo(() => {
    return data.filter((row) => {
      return Object.keys(filters).every((columnId) => {
        const cellValue = getNestedValue(row, columnId)?.toString().toLowerCase();
        const filterValue = filters[columnId]?.toLowerCase() || "";
        return cellValue?.includes(filterValue);
      });
    });
  }, [data, filters]);

  return { filters, handleFilterChange, filteredData };
};

export default useTableFilters;
